<template>
    <div>
        <div
            @click="toggleModal(true)"
            class="flex flex-row my-1 cursor-pointer">
            <span class="flex-grow md:flex-grow-0 text-center text-white bg-blue-600 p-3 rounded-l-lg">
                Current Balance
            </span>
            <button
                v-if="value3 && value3 !== ''"
                data-cy="buttonEditCurrent"
                class="flex-grow md:flex-grow-0 text-white text-right font-bold p-2 pr-4 rounded-r-lg rightColumn"
                :class="[value3.value_ !== 0 && value3.value_ !== '' ? 'bg-blue-600' : 'bg-orange-500']"
                style="color: #ecf0f1;"
            >
                {{ value3.value_ | eur }}
            </button>
        </div>
        <Modal v-if="cModal" mode="current">
            <h2 class="text-4xl text-center font-hairline md:leading-loose text-grey md:mt-8 mb-4">Enter current balance:</h2>
            <p class="text-xl leading-normal mb-8 text-center">
                enter your current balance<br> at your bank account
            </p>
            <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                    <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-balance">
                        Balance
                    </label>
                </div>
                <div class="md:w-2/3">
                    <input
                        class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                        id="inline-balance"
                        type="number"
                        placeholder="1000"
                        data-cy="currentValue"
                        v-model.number="changedValue"
                    >
                </div>
            </div>
            <div class="md:flex md:items-center">
                <div class="md:w-1/3"></div>
                <div class="md:w-2/3">
                    <!-- <button
                        @click="addPayment()"
                        class="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 m-2 rounded" type="button"
                    >
                        Save
                    </button> -->
                    <button
                        data-cy="buttonSaveExit"
                        @click.stop="addCurrent();toggleModal(false);"
                        class="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 m-2 rounded" type="button"
                    >
                        Save &amp; Exit
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
// import { db } from '@/db.js';
import { mapFields } from 'vuex-map-fields';
import Modal from '@/components/Modal.vue';

export default {
    name: 'Current',
    components: {
        Modal,
    },
    data() {
        return {
            changedValue: 0,
        };
    },
    computed: {
        ...mapFields([
            // 'current.value',
            'toggle.current.cModal',
            'user.uid',
        ]),
        ...mapFields({
            value3: 'current',
        }),
    },
    created() {
        // console.log('created Current');
        this.$store.dispatch('bindCurrent')
            .then(() => {
                // console.log('docCurrent:', doc);
                // // console.log('doc.value:', doc.value_);
                // console.log('doc.value:', doc.value_);
                // console.log('this.$store.state.current:', this.$store.state.current);
                this.currentValue = this.$store.state.current;
                // this.changedValue = doc.value_;
            });
    },
    methods: {
        addCurrent() {
            // console.log('this.changedValue:', this.changedValue);
            this.$store.dispatch('updateCurrent', this.changedValue);
        },
        toggleModal(open) {
            this.$store.commit('SET_CURRENT_MODAL', open);
        },
    },
};
</script>

<style scoped>
.rightColumn {
    min-width: 10rem;
}
</style>
